import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ImageEditorComponent } from '../image-editor/image-editor.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HeaderBarEvents, HeaderBarListenerService } from '../../../../services/header-bar-listener.service';
import { LegFiJwtService } from '../../../../services/auth/legfi-jwt.service';
import { OrganizationService } from '../../../../services/organization/organization.service';
import { environment } from '../../../../../environments/environment';
import { GrowlerService } from '../../../../services/growler.service';

@UntilDestroy()
@Component({
    selector: 'app-organization-logo',
    templateUrl: './organization-logo.component.html',
})
export class OrganizationLogoComponent implements OnInit {
    @Input() organizationId: number;
    @Input() orgLogoURL: string = '';
    @Input() fallbackLogo: boolean;

    @ViewChild('imageEditor', {read: ImageEditorComponent}) imageEditor: ImageEditorComponent;
    isReplacingLogo = false;

    constructor(
            private _organizationService: OrganizationService,
            private _legFiJwtService: LegFiJwtService,
            private _headerBar: HeaderBarListenerService,
            private _growler: GrowlerService,
    ) { }

    ngOnInit(): void {
    }

    onOrgLogoUpload(base64Image: string) {
        const requestBody: {
            [key: string]: any
        } = {};
        const imageParts = base64Image.split(',');
        if (imageParts.length === 2) {
            requestBody['orgLogo'] = imageParts[1];
        } else {
            requestBody['orgLogo'] = base64Image;
        }

        this._organizationService.updateOrganization(requestBody).pipe(untilDestroyed(this)).subscribe({
            next: () => {
                const jwt = this._legFiJwtService.readOrRedirect();
                if (jwt !== null) {
                    this._headerBar.changeImage(jwt.orgId, HeaderBarEvents.OrgLogoImageChange);
                }
                this.imageEditor.resetAfterUpload();

                // Adding to prevent lingering cached profile image after update.
                const noCache = '?nocache=' + new Date().getTime();
                this.orgLogoURL = `${environment.S3URL + environment.OrgLogoBucket}/${this.organizationId.toString()}/logo.png${noCache}`;

                this.isReplacingLogo = false;
                this._growler.success('Success', 'The organization logo has been updated to your image.');
            },
            error: () => this._growler.error('Error', 'There was a problem updating the organization logo.'),
        });
    }

    resetOrgLogo() {
        this._organizationService.deleteOrganizationLogo(null).pipe(untilDestroyed(this)).subscribe({
            next: () => {
                const jwt = this._legFiJwtService.readOrRedirect();
                if (jwt !== null) {
                    this._headerBar.changeImage(jwt.orgId, HeaderBarEvents.OrgLogoRemoval);
                }
                this._growler.success('Success', 'The organization logo has been reset to default.');
                this.orgLogoURL = '';
            },
            error: () => this._growler.error('Error', 'There was a problem resetting the organization logo.'),
        });
    }
}
